export default __webpack_public_path__ + "3a9ffc36ffd66a8c27ddc02cc57d6a96.png";